module.exports = __webpack_public_path__ + "img/mob_home_googleplay.b916d7ae.png";